import { HOST } from '../constants';

export const UPDATE_PAYMENT_STATUS = `${HOST}/billings/update_payment_status`;
